/**
 * @fileoverview GET handler for the "/companies/:company_id/app_group_permission_sets/permission_set/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdAppGroupPermissionSetsPermissionSetId } from "./constants";
import type { CompaniesCompanyIdAppGroupPermissionSetsPermissionSetIdResult } from "./types";

export const getCompaniesCompanyIdAppGroupPermissionSetsPermissionSetId = reactQueryFetcherAdapter(
  companiesCompanyIdAppGroupPermissionSetsPermissionSetId,
  (
    signal: AbortSignal,
    companyId: string,
    id: string
  ): Promise<CompaniesCompanyIdAppGroupPermissionSetsPermissionSetIdResult> => {
    return fetch(`/companies/${companyId}/app_group_permission_sets/permission_set/${id}`, "GET", {}, { signal });
  }
);
